import { Grid, styled } from "@mui/material";
import React from "react";
interface MxCPropertyRainbowLabelProps {
  children: any;
  background?: string;
  variant: "top-left" | "top-right" | "bottom-left" | "bottom-right";
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
}
const MxCPropertyRainbowLabel = (props: MxCPropertyRainbowLabelProps) => {
  return <ContentRainbow {...props} />;
};

export default MxCPropertyRainbowLabel;

const ContentRainbow = styled(Grid)<{
  variant: "top-left" | "top-right" | "bottom-left" | "bottom-right";
  background?: string;
}>(({ theme, variant, background }) => ({
  position: "absolute",
  fontWeight: 400,
  color: "white",
  padding: "0.3rem 1.5rem",
  background: background ?? theme.palette.primary.main,
  fontSize: 12,
  ...p[variant]
}));

const p = {
  "top-left": {
    top: "0",
    left: "0",
    borderTopLeftRadius: 10,
    borderBottomRightRadius: 10
  },
  "top-right": {
    top: "0",
    right: "0",
    borderTopRightRadius: 10,
    borderBottomLeftRadius: 10
  },
  "bottom-left": {
    bottom: "0",
    left: "0",
    borderTopRightRadius: 10
  },
  "bottom-right": {
    bottom: "0",
    right: "0",
    borderTopLeftRadius: 10,
    cursor: "pointer"
  }
};
